var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsAdjustO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2559 14.5833H6.66675C5.97639 14.5833 5.41675 14.0237 5.41675 13.3333C5.41675 12.643 5.97639 12.0833 6.66675 12.0833H22.2559C22.8 10.1596 24.5688 8.75 26.6667 8.75C28.7647 8.75 30.5334 10.1596 31.0776 12.0833H33.3334C34.0238 12.0833 34.5834 12.643 34.5834 13.3333C34.5834 14.0237 34.0238 14.5833 33.3334 14.5833H31.0776C30.5334 16.5071 28.7647 17.9167 26.6667 17.9167C24.5688 17.9167 22.8 16.5071 22.2559 14.5833ZM24.5834 13.3333C24.5834 12.1827 25.5162 11.25 26.6667 11.25C27.8173 11.25 28.7501 12.1827 28.7501 13.3333C28.7501 14.4839 27.8173 15.4167 26.6667 15.4167C25.5162 15.4167 24.5834 14.4839 24.5834 13.3333Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7442 27.9167H33.3334C34.0238 27.9167 34.5834 27.357 34.5834 26.6667C34.5834 25.9763 34.0238 25.4167 33.3334 25.4167H17.7442C17.2001 23.4929 15.4314 22.0833 13.3334 22.0833C11.2355 22.0833 9.46672 23.4929 8.92261 25.4167H6.66675C5.97639 25.4167 5.41675 25.9763 5.41675 26.6667C5.41675 27.357 5.97639 27.9167 6.66675 27.9167H8.92261C9.46672 29.8404 11.2355 31.25 13.3334 31.25C15.4314 31.25 17.2001 29.8404 17.7442 27.9167ZM11.2501 26.6667C11.2501 25.5161 12.1828 24.5833 13.3334 24.5833C14.484 24.5833 15.4167 25.5161 15.4167 26.6667C15.4167 27.8173 14.484 28.75 13.3334 28.75C12.1828 28.75 11.2501 27.8173 11.2501 26.6667Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsAdjustO);
export default __webpack_public_path__ + "static/media/settings-adjust-o.0752f06d45aa5303f41f3e33b183895a.svg";
export { ForwardRef as ReactComponent };